"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.interceptConsole = exports.consoleHandlerFactory = void 0;
const consoleHandlerFactory = (emitter) => {
    const createHandler = (type) => ({
        apply: function (target, thisArg, argumentsList) {
            const timestamp = Date.now();
            emitter.emit('consoleAPIHasBeenCalled', {
                argumentsList,
                type,
                timestamp,
            });
            return Reflect.apply(target, thisArg, argumentsList);
        },
    });
    return createHandler;
};
exports.consoleHandlerFactory = consoleHandlerFactory;
const interceptConsole = (emitter) => {
    const createHandler = (0, exports.consoleHandlerFactory)(emitter);
    console.log = new Proxy(console.log, createHandler('log'));
    console.error = new Proxy(console.error, createHandler('error'));
    console.warn = new Proxy(console.warn, createHandler('warn'));
    console.info = new Proxy(console.info, createHandler('info'));
};
exports.interceptConsole = interceptConsole;
